import { Button } from 'react-bootstrap';
import { CombinedVenue } from 'types/models';
import { Link } from 'react-router-dom';
import { useSalesAreas } from 'contexts/VenueContext';
import { IoEllipsisHorizontalCircle } from 'react-icons/io5';
import { ConfirmLeaveCheckoutModal } from 'venue/components/ConfirmLeaveCheckoutModal';
import { useState } from 'react';
import { useHistory } from 'react-router';
import { useLoyaltyRewards } from 'contexts/LoyaltyRewardContext';
import { useGiftCard } from 'contexts/GiftCardContext';
import { useVouchers } from 'contexts/VoucherContext';

interface VenueInfoHeaderProps {
  venue: CombinedVenue;
  handleOpen?: () => void;
  isTitleLink?: boolean;
  isOnCheckoutPage?: boolean;
}

export const VenueInfoHeader: React.FC<VenueInfoHeaderProps> = ({
  venue,
  handleOpen,
  isTitleLink = false,
  isOnCheckoutPage,
}) => {
  const { selectedSalesArea } = useSalesAreas();
  const hasMultipleSalesAreas = venue.salesArea.length > 1;
  const salesAreaName =
    hasMultipleSalesAreas && selectedSalesArea && !handleOpen
      ? ` (${selectedSalesArea.name})`
      : '';
  const [showLeaveCheckoutModal, setShowLeaveCheckoutModal] =
    useState<boolean>(false);
  const history = useHistory();

  const { redeemedLoyaltyRewards } = useLoyaltyRewards();
  const { redeemedGiftCards } = useGiftCard();
  const { redeemedVouchers } = useVouchers();

  const hasLoyaltyRewards = redeemedLoyaltyRewards.length > 0;
  const hasGiftCards = redeemedGiftCards.length > 0;
  const hasRedeemedVouchers = redeemedVouchers.length > 0;

  const hasRedeemables =
    hasRedeemedVouchers || hasLoyaltyRewards || hasGiftCards;

  const handleLeaveCheckout = () => {
    setShowLeaveCheckoutModal(false);
    history.push(`/venue/${venue.id}`);
  };

  return (
    <>
      <div className="venue-info-header" data-testid="link-venue-header">
        <div
          className="venue-info-header-title"
          data-testid="link-venue-header-title"
        >
          <h4>
            {isTitleLink ? (
              <Link
                onClick={(e) => {
                  if (isOnCheckoutPage && hasRedeemables) {
                    e.preventDefault();
                    setShowLeaveCheckoutModal(true);
                  }
                }}
                to={`/venue/${venue.id}`}
              >
                {venue.name}
              </Link>
            ) : (
              venue.name
            )}
            {salesAreaName}
          </h4>
          {handleOpen ? (
            <Button
              className="icon-button"
              onClick={handleOpen}
              aria-label="Open venue details"
            >
              <IoEllipsisHorizontalCircle size={24} />
            </Button>
          ) : null}
        </div>
      </div>
      <ConfirmLeaveCheckoutModal
        show={showLeaveCheckoutModal}
        dismiss={() => setShowLeaveCheckoutModal(false)}
        proceed={() => handleLeaveCheckout()}
      />
    </>
  );
};
